export enum RunType {
  Regular = 'regular',
  AddDocs = 'addDocs',
  AddDocsUpdateSynopsis = 'addDocsUpdateSynopsis',
  UpdateSynopsis = 'updateSynopsis',
  UpdateInconsistencies = 'updateInconsistencies',
  DeleteDocuments = 'deleteDocuments',
}
